import { useMemo } from "react";
import { useIntl } from "react-intl";
import { useParams } from "react-router-dom";
import { Row, useExpanded, useSortBy, useTable } from "react-table";

import { useGetQuoteRequestDetails } from "api/queries/quotes/useGetQuoteRequestDetails";
import Dialog from "components/organisms/Dialog/Dialog";
import DataTable from "components/organisms/DataTable/DataTable";
import getCommoditiesColumns from "./commoditiesColumns";
import SubCommodity from "./SubCommodity";

interface CommoditiesDialogProps {
  isOpen: boolean;
  close: () => void;
}

export default function CommoditiesDialog({ isOpen, close }: CommoditiesDialogProps) {
  const intl = useIntl();
  const id = useParams().id?.toUpperCase();

  const { data: quoteRequestDetails } = useGetQuoteRequestDetails({
    shipmentId: id!,
    options: {
      enabled: !!id,
      refetchOnMount: false,
    },
  });

  const goodItems = useMemo(() => quoteRequestDetails?.organization?.good_items ?? [], [quoteRequestDetails]);
  const columns = useMemo(() => getCommoditiesColumns({ intl }), []);

  const onRowClick = (row: Row<any>) => {
    row.toggleRowExpanded();
  };

  const instance = useTable<any>(
    {
      columns,
      data: goodItems,
    },
    useSortBy,
    useExpanded,
  );

  return (
    <Dialog
      title={intl.formatMessage({
        id: "general.commodities",
        defaultMessage: "Commidities",
      })}
      show={isOpen}
      onHide={close}
      className="commodities-dialog"
    >
      <div style={{ margin: "-1.333rem" }}>
        <DataTable tableInstance={instance} draggable={false} onRowClick={onRowClick} RowSubComponent={SubCommodity} />
      </div>
    </Dialog>
  );
}
